// extracted by mini-css-extract-plugin
module.exports = {"counter":"AmenityCounter_counter__9CuoR","icon":"AmenityCounter_icon__FKTWF","label":"AmenityCounter_label__Kdayh","sm":"AmenityCounter_sm__5LlqC","md":"AmenityCounter_md__RWu1N"};